import { send_genieTrip_search } from "./page-scripts/genieTrip_scripts";
import { start_genieTrip_log, stop_genieTrip_log, takeGenieTrip_log, frvt_click_log } from "./log";
import { waitFor, check_driveTimeStr_getNum  } from "./util/general_util";
import { StopByStopTrip_autofill } from "./util/autofill_scripts";

// require('jqueryui');
if (window.location.pathname.includes("rv-trips")) {
	let pathname_split:Array<string> = window.location.pathname.split("/");
	if (pathname_split.length >= 3) {
		//only want this for specific trip page, not /rv-trips
		// let trip_url_ext:string = pathname_split[pathname_split.length - 1];
		// start_genieTrip_log(trip_url_ext);
		// window.addEventListener("beforeunload", function() {
		// 	stop_genieTrip_log();
		// });

		// let typingTimer: ReturnType<typeof setTimeout>;
		// const doneTypingInterval = 250;
		// $(document).on("keydown", ".stop-by-stop-input", (event: JQuery.KeyboardEventBase<any, any, any, any>) => {
		// 	clearTimeout(typingTimer);
		// 	typingTimer = setTimeout(function() {
		// 		$(".stop-by-stop-input").off("keydown");
		// 		StopByStopTrip_autofill(event);
		// 	}.bind(this),doneTypingInterval);
		// });
	}


} else {
	stop_genieTrip_log();
};
if (window.location.pathname.includes("rv-trips")) {
	$(document).on("click", "#takeGenieTrip-dummy", function() {
		$("#takeGenieTrip_anonUser_modal").modal("show");
	});

	$(document).on("click","#takeGenieTrip-openSettings", function(event) {
		event.stopPropagation();
		let genieTripSettings_modal =$("#takeGenieTrip_modal");
		genieTripSettings_modal.find(".modal-title[takeTripAllowed]").html(`Configure Your Route Preferences for:</br><em>${$("#genieTrip_tripName").html()}</em>`);

		genieTripSettings_modal.find("#genieTrip-startLABEL").html(`Trip Start - <i>${$(".destination-coord#0").attr("dest_str")}</i>`);

		genieTripSettings_modal.find("#genieTrip-endLABEL").html(`Trip End - <i>${$(".destination-coord").last().attr("dest_str")}</i>`);

		genieTripSettings_modal.modal("show");
	});

	$(document).on("click","#showSetStart", function() {
		$(this).hide();
		$("#setStartInput").show();
	});

	$(document).on("click", "#showSetEnd", function() {
		$(this).hide();
		$("#setEndInput").show();
	});

	$(document).on("hide.bs.modal", "#takeGenieTrip_modal", () => {
		$("#genieTrip-start").val("");
		$("#genieTrip-end").val("");
	});

	$("#takeGenieTrip").on("click", function():void {
		let stopSetCoords:Array<{
			id:number,
			lat:number,
			lon:number,
			dest_str:string,
			geo_str:string
		}> = [];
		let stopSetData_el:JQuery<HTMLElement> = $("#stopSet");
		let stopSetCoords_els:JQuery<HTMLElement> = stopSetData_el.find(".destination-coord");

		let driveTime:number;
		let driveTime_str:string;
		let routeWidth:number;
		let avoidHighways:number;

		let routeStart_query:string = $("#genieTrip-start").val().toString();
		let routeEnd_query:string = $("#genieTrip-end").val().toString();

		let routeStart_query_type:string|null = $("#genieTrip-start").attr("query_type");
		let routeStart_query_val:string|null = $("#genieTrip-start").attr("query_val");

		let routeEnd_query_type:string|null = $("#genieTrip-end").attr("query_type");
		let routeEnd_query_val:string|null = $("#genieTrip-end").attr("query_val");

		let isFantasyTour:string = $("#isFRVTTour").val().toString();
		if (routeStart_query_type == undefined || routeStart_query_val == undefined || routeStart_query.length <= 1) {
			routeStart_query_type = null;
			routeStart_query_val = null;
			$("#genieTrip-start").val("");
		};

		if (routeEnd_query_type == undefined || routeEnd_query_val == undefined || routeEnd_query.length <= 1) {
			routeEnd_query_type = null;
			routeEnd_query_val = null;
			$("#genieTrip-end").val("");
		};

		if ($("#drive-time").length) driveTime_str = $("#drive-time").val().toString();
		else driveTime_str = "";
		if (driveTime_str.length == 0) {
			//set default time 6hrs
			driveTime_str = "06:00";
		};

		let driveDist:number|string = $("#drive-dist").val() as number|string;
		if (typeof(driveDist) == "string") {
			driveDist = parseInt(driveDist);
		};
		if (Number.isNaN(driveDist)) {
			driveDist = 300;
			$("#drive-dist").val(driveDist);
		};

		if ((driveTime = check_driveTimeStr_getNum(driveTime_str)) == 0) return null;

		routeWidth = parseInt($("input[name='route-width']:checked").val().toString());

		//TODO: uncomment this if we add avoid-highways option on genie trips screen
		avoidHighways = 0;

		stopSetCoords_els.each(function() {
			stopSetCoords.push({
				id: parseInt($(this).attr("id")),
				lat: parseFloat($(this).attr("lat")),
				lon: parseFloat($(this).attr("lon")),
				dest_str: encodeURIComponent($(this).attr("dest_str")),
				geo_str: encodeURIComponent($(this).attr("geo_str")),
			});
		});

		if ((stopSetCoords.length == 1) && ((routeStart_query === "") || (routeEnd_query === ""))) {
			$("[trip_errEl]").find("[errMsg]").html("Please add a start and end destination to take this trip.");
			$("[trip_errEl]").removeClass("d-none");
			return
		};

		let tripID:string = $("#tripID").val() as string;
		let trip_url_encoded:string = `/tripPlanner?genieTrip=${JSON.stringify(stopSetCoords)}&tripID=${tripID}&driveTime=${driveTime}&driveDist=${driveDist}&routeWidth=${routeWidth}&avoidHighways=${avoidHighways}&isFRVT=${isFantasyTour}`;

		if (routeStart_query != "" && routeStart_query.length > 1) trip_url_encoded += `&start=${routeStart_query}&start_query_type=${routeStart_query_type}&start_query_val=${routeStart_query_val}`;

		if (routeEnd_query != "" && routeEnd_query.length > 1) trip_url_encoded += `&end=${routeEnd_query}&end_query_type=${routeEnd_query_type}&end_query_val=${routeEnd_query_val}`;

		let pathname_split:Array<string> = window.location.pathname.split("/");
		let trip_url_ext:string = pathname_split[pathname_split.length - 1];

		takeGenieTrip_log(trip_url_ext);

		window.location.href = window.location.origin + trip_url_encoded;
	});

	//SEARCH BAR
	$(document).on("keydown", "#genieTrip_search_query", (event: { key: string; }) => {
		if ((event.key == "Enter") && $("#genieTrip_search_query").val().toString().length > 2){
			send_genieTrip_search()
		};
	});

	$(document).on("click","#submit_genieTrip_search_query",function() {
		if ($("#genieTrip_search_query").val().toString().length > 2){
			send_genieTrip_search()
		};
	});

	$(document).on("click","[bookFRVT_Tour]",function() {

		let tourName:string = $("#genieTrip_tripName").text();
		let tourDate:string = $(this).prev("[frvt_tour_date]").text();

		frvt_click_log(tourName,tourDate);
	});

	$(document).off("shown.bs.collapse",'[desktopTripItinerary]');
	$(document).on("shown.bs.collapse",'[desktopTripItinerary]',function(event) {
		const offset = $(this).closest(".accordion-item").offset().top - 80;
		$('html, body').animate({
			scrollTop:offset
		},400);
	})
};